import { render, staticRenderFns } from "./CarouselBooks.vue?vue&type=template&id=447e159b&scoped=true&"
import script from "./CarouselBooks.vue?vue&type=script&lang=js&"
export * from "./CarouselBooks.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBooks.vue?vue&type=style&index=0&id=447e159b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447e159b",
  null
  
)

export default component.exports